<template>
  <div class="text-sm text_color">
    <span v-if="isUnlimited">No credit limit</span>
    <span v-else>{{ formattedCredits }} credits</span>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  row: { type: Object, required: true },
});

// Users.vue's resolveCreditLimit sets credit_limit to null for rows that are disabled,
// unlimited, or missing a budget entry — so a single null check covers every "unlimited" case.
const isUnlimited = computed(() => props.row?.credit_limit == null);

const formattedCredits = computed(() =>
  Number(props.row?.credit_limit ?? 0).toLocaleString("en-US")
);
</script>
